import React from 'react';
import { Card, Label, Image, Divider } from 'semantic-ui-react';

const cardStyle = {
  textAlign: 'center',
  boxShadow: 'none',
};

const hrStyle = {
  borderTop: '1px dashed #',
  marginTop: 20,
  marginBottom: 20,
};

const NoAssetsCard = () => (
  <Card fluid style={cardStyle}>
    <Card.Content>
      <h3>No posts yet!</h3>
      <Divider hidden />
      <Image src="/images/empty-campaigns.svg" />
      <Divider hidden />
      <span>you can add them manually using the </span>
      <Label content="Add Post" color="pink" icon="plus" basic /> <span>button above <br />or wait for them to be found automatically</span>
    </Card.Content>
  </Card>
);

export default NoAssetsCard;



/** WEBPACK FOOTER **
 ** ./src/components/no-assets-card/index.js
 **/